<template>
    <div>
        <div v-if="nowActive=='all'" id="sortDiv" class="sort_box_postion" v-bind:style="menu.all.sortDivStyle">
			<sort v-on:sortOrderTime="onsortOrderTime" v-on:sortTravelTime="onsortTravelTime" 
			 v-bind:viewInvoice=menu.all.viewInvoice
			 v-bind:viewInvoiceNum=menu.all.viewInvoiceNum 
             v-bind:invoiceUrl=menu.all.invoiceUrl
             v-bind:initSortType=menu.all.sortType ></sort>
		</div>
        <div class="consult_null" v-if="!menu[nowActive].isDownLoading && allOrderItems[nowActive].length == 0"  @click.stop="goConsult">订单问题咨询</div>
        <navbar @selectMenuType="selectMenuType" :menu="menu" :nowActive="nowActive"></navbar>
        <scroller :style="{'padding-top':'90px','display':nowActive == 'all'? 'block':'none'}" :on-refresh="refreshAll" :on-infinite="infiniteAll" ref="my_scrollerAll" :height="scrollHeight" :isShowDownLoading="menu.all.isShowDownLoading" :noDataText="menu.all.noDataText">
            <div class="first-load" v-if="menu.all.isFirstLoading">
                <img src="//file.40017.cn/touchweixinqq/weixin/public/img/loading.svg" />
            </div>
            <template v-else>
            <div v-if="allOrderItems.all.length >= 0">
                <div v-for="(item, index) in allOrderItems.all" :key="item.SerialNo +''+ item.OrderId + index" v-if="item.type !== 'date'">
                    <div class="cuttingLine" v-if="item.type && item.type == 'cuttingLine' && index != allOrderItems.all.length - 1">
                        <span class="cuttingtext">——&nbsp;&nbsp;&nbsp;以下是{{transformNum(pageSetting.NormalMonths)}}个月前的订单哦&nbsp;&nbsp;&nbsp;——</span>
                    </div>
                    <orderItem v-if="!item.type || item.type != 'cuttingLine'"
                        :iteminfo="item" 
                        :position="index"
                        @closeMore="closeMore"
                        :actposition="actposition"
                        :itemindex="index"
                        :cancelReasonProjects="pageSetting.cancelReasonProjects"  class="orderItems"  @deleteItem="deleteItem" @cancelItem="cancelItem">
                    </orderItem>
                </div>
                <div v-else-if="allOrderItems.all[index + 1] && (allOrderItems.all[index + 1].type !== 'date' && allOrderItems.all[index + 1].type !== 'cuttingLine')" class="my-item-date">
                    <div>{{item.content}}</div>
                </div>
            </div>
            <div v-if="!menu.all.isDownLoading && allOrderItems.all.length == 0" class="no-data-show">
                <div v-if="allOrderItems.all.length == 0 && !menu.all.requestError" class="enpty-order">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/indent_null.png">
                    <div v-if="menu.all.getMonthsDes == 'gt' || !pageSetting.InForce || menu.all.noThreeMonthOrder">
                        <p>暂无一年内的订单哟~</p>                        
                    </div>
                    <div v-else>
                        <p style="margin-bottom: 30px;">暂无{{transformNum(pageSetting.NormalMonths)}}个月内的订单哟~</p>
                        <div class="gt-btn" @click="getGTOrder">查看{{transformNum(pageSetting.NormalMonths)}}个月前的订单</div>
                    </div>
                </div>
                <div v-if="menu.all.requestError" class="request-error">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/data_error.png">
                    <p>额哦，暂未获取到您的订单<br />请稍后再试~</p>
                </div>
            </div>
            <div v-if="menu.all.getMonthsDes == 'gt' || !pageSetting.InForce || menu.all.noThreeMonthOrder" slot="bottom-tip" class="consult-box">
                <p>—— &nbsp;&nbsp;&nbsp;到底啦，已展示最近一年的订单，没有更多了~&nbsp;&nbsp;&nbsp;——</p>
                <div class="consult" @click.stop="goConsult">订单问题咨询</div>
            </div>
            <div v-else slot="bottom-tip">
                <div class="gtBtn-box">
                    <div class="gt-btn" @click="getGTOrder">查看{{transformNum(pageSetting.NormalMonths)}}个月前的订单</div>
                    <div class="consult" @click.stop="goConsult">订单问题咨询</div>
                </div>
            </div>
            </template>
        </scroller>
        <scroller :style="{'padding-top':'50px','display':nowActive == 'waitApply'? 'block':'none'}" :on-refresh="refreshApply" :on-infinite="infiniteApply" ref="my_scrollerApply" :height="scrollHeight" :isShowDownLoading="menu.waitApply.isShowDownLoading" :noDataText="menu.waitApply.noDataText">
            <div class="first-load" v-if="menu.waitApply.isFirstLoading">
                <img src="//file.40017.cn/touchweixinqq/weixin/public/img/loading.svg" />
            </div>
            <template v-else>
            <div v-if="allOrderItems.waitApply.length > 0">
                <orderItem v-for="(item, index) in allOrderItems.waitApply" 
                    :iteminfo="item" 
                    :itemindex="index" class="orderItems" v-if="item.type !== 'date'" 
                    :position="index"
                    @closeMore="closeMore"
                    :actposition="actposition"
                    :cancelReasonProjects="pageSetting.cancelReasonProjects" 
                    :key="item.SerialNo +''+ item.OrderId + '' + index" @deleteItem="deleteItem" @cancelItem="cancelItem">
                </orderItem>
                <div v-else-if="allOrderItems.waitApply[index + 1] && allOrderItems.waitApply[index + 1].type !== 'date'" class="my-item-date">
                    <div>{{item.content}}</div>
                </div>
            </div>
            <div class="no-data-show" v-if="!menu.waitApply.isDownLoading && allOrderItems.waitApply.length == 0">
                <div v-if="allOrderItems.waitApply.length == 0 && !menu.waitApply.requestError" class="enpty-order">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/indent_null.png">
                    <p>{{menu.waitApply.nodata}}</p>
                </div>
                <div v-if="menu.waitApply.requestError" class="request-error">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/data_error.png">
                    <p>额哦，暂未获取到您的订单<br />请稍后再试~</p>
                </div>
            </div>
            <div slot="bottom-tip" class="consult-box">
                <p>—— &nbsp;&nbsp;&nbsp;到底啦，已展示最近一年的订单，没有更多了~&nbsp;&nbsp;&nbsp;——</p>
                <div class="consult" @click.stop="goConsult">订单问题咨询</div>
            </div>
            </template>
        </scroller>
        <scroller :style="{'padding-top':'50px','display':nowActive == 'waitGoing'? 'block':'none'}" :on-refresh="refreshGoing" :on-infinite="infiniteGoing" ref="my_scrollerGoing" :height="scrollHeight" :isShowDownLoading="menu.waitGoing.isShowDownLoading" :noDataText="menu.waitGoing.noDataText">
            <div class="first-load" v-if="menu.waitGoing.isFirstLoading">
                <img src="//file.40017.cn/touchweixinqq/weixin/public/img/loading.svg" />
            </div>
            <template v-else>
            <div v-if="allOrderItems.waitGoing.length > 0">
                <orderItem v-for="(item, index) in allOrderItems.waitGoing" 
                    :iteminfo="item" 
                    :position="index"
                    :actposition="actposition"
                    @closeMore="closeMore"
                    :itemindex="index"
                    :cancelReasonProjects="pageSetting.cancelReasonProjects"  class="orderItems" v-if="item.type !== 'date'" :key="item.SerialNo +''+ item.OrderId + '' + index" @deleteItem="deleteItem" @cancelItem="cancelItem">
                </orderItem>
                <div v-else-if="allOrderItems.waitGoing[index + 1] && allOrderItems.waitGoing[index + 1].type !== 'date'" class="my-item-date">
                    <div>{{item.content}}</div>
                </div>
            </div>
            <div v-if="!menu.waitGoing.isDownLoading && allOrderItems.waitGoing.length == 0" class="no-data-show">
                <div v-if="allOrderItems[nowActive].length == 0 && !menu.waitGoing.requestError" class="enpty-order">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/indent_null.png">
                    <p>{{menu.waitGoing.nodata}}</p>
                </div>
                <div v-if="menu.waitGoing.requestError" class="request-error">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/data_error.png">
                    <p>额哦，暂未获取到您的订单<br />请稍后再试~</p>
                </div>
            </div>
            <div slot="bottom-tip" class="consult-box">
                <p>—— &nbsp;&nbsp;&nbsp;到底啦，已展示最近一年的订单，没有更多了~&nbsp;&nbsp;&nbsp;——</p>
                <div class="consult" @click.stop="goConsult">订单问题咨询</div>
            </div>
            </template>
        </scroller>
        <scroller :style="{'padding-top':'50px','display':nowActive == 'waitEvaluate'? 'block':'none'}" :on-refresh="refreshEvaluate" :on-infinite="infiniteEvaluate" ref="my_scrollerEvaluate" :height="scrollHeight" :isShowDownLoading="menu.waitEvaluate.isShowDownLoading"
            :noDataText="menu.waitEvaluate.noDataText">
            <div class="first-load" v-if="menu.waitEvaluate.isFirstLoading">
                <img src="//file.40017.cn/touchweixinqq/weixin/public/img/loading.svg" />
            </div>
            <template v-else>
            <div v-if="allOrderItems.waitEvaluate.length > 0">
                <orderItem v-for="(item, index) in allOrderItems.waitEvaluate" 
                    :position="index"
                    :iteminfo="item" 
                    :actposition="actposition"
                    @closeMore="closeMore"
                    :itemindex="index"
                    :cancelReasonProjects="pageSetting.cancelReasonProjects"  class="orderItems" v-if="item.type !== 'date'" :key="item.SerialNo +''+ item.OrderId + '' + index" @deleteItem="deleteItem" @cancelItem="cancelItem">
                </orderItem>
                <div v-else-if="allOrderItems.waitEvaluate[index + 1] && allOrderItems.waitEvaluate[index + 1].type !== 'date'" class="my-item-date">
                    <div>{{item.content}}</div>
                </div>
            </div>
            <div v-if="!menu.waitEvaluate.isDownLoading && allOrderItems.waitEvaluate.length == 0" class="no-data-show">
                <div v-if="allOrderItems.waitEvaluate.length == 0 && !menu.waitEvaluate.requestError" class="enpty-order">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/indent_null.png">
                    <p>{{menu.waitEvaluate.nodata}}</p>
                </div>
                <div v-if="menu.waitEvaluate.requestError" class="request-error">
                    <img src="https://file.40017.cn/tcservice/wxapp/chat/image/data_error.png">
                    <p>额哦，暂未获取到您的订单<br />请稍后再试~</p>
                </div>
            </div>
            <div slot="bottom-tip" class="consult-box">
                <p>—— &nbsp;&nbsp;&nbsp;到底啦，已展示最近一年的订单，没有更多了~&nbsp;&nbsp;&nbsp;——</p>
                <div class="consult" @click.stop="goConsult">订单问题咨询</div>
            </div>
            </template>
        </scroller>
        <showmodel ref="showModal"></showmodel>
        <cancelDialog ref="cancelDialog"></cancelDialog>
        <toappmodel v-if="isViewWin"></toappmodel>        
        <toappbuoy v-if="isViewBuoy"></toappbuoy>        
    </div>
</template>

<script>
    //由于最后才使用四个scroller，导致scrolle未封装成组件，都写到这一个VUE中，共有4个scroller
    import scroller from './../components/scroller/components/Scroller.vue'
    import navbar from './../components/navbar.vue'
    import sort from './../components/sort.vue'
    import toappmodel from './../components/toappmodel.vue'
    import toappbuoy from './../components/toappbuoy.vue'
    import {
        getStrFromUrl,
        shallowClone,
        addCookie,
        changeTitle
    } from './../util/tool.js'
    import axios from 'axios'
    import {
        order,
        canceldata,
        orderArray
    } from '../util/order.js'
    import orderItem from '../components/orderitem.vue'
    import showmodel from '../components/showmodel'
    import cancelDialog from '../components/cancel'
    import {
        api,
        devType,
        miniAppVer,
        enterType,
        miniOrderVer
    } from './../util/api.js'
    import Bus from '../components/bus.js'
    const weekday = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
    export default {
        name: 'App',
        components: {
            navbar,
            orderItem,
            scroller,
            showmodel,
            cancelDialog,
            sort,
            toappmodel,
            toappbuoy
        },
        data() {
            return {
                menu: {
                    all: {
                        name: '全部订单',
                        active: 0,
                        value: 'all',
                        scrollPosition: 0, //滚动位置
                        nodata: '请点击右上角的分类订单找找看~',
                        isFirstLoading: true, //第一次加载
                        isShowDownLoading: false, //是否显示加载
                        requestError: false, //请求接口错误
                        isDownLoading: false, //是否正在请求数据
                        pageFull: 0, //第一个接口的页数
                        orderFilter: 0, //过滤参数
                        isFullNodata: false, //第一个请求无数据
                        isReply: false, //避免重复请求
                        time: 0,
                        freshNumber: 0,
                        lastTime: '',
                        noDataText: "到底了，在右上角的分类订单找找看~",
                        getMonthsDes: 'leq',
                        noThreeMonthOrder:false,
                        sortType: 0,
                        sortDivStyle:"",
                        viewInvoice: false,
                        viewInvoiceNum : 0,
                        invoiceUrl: "",                        
                    },
                    waitApply: {
                        name: '待付款',
                        active: 0,
                        value: 'waitApply',
                        scrollPosition: 0,
                        nodata: '暂无待付款订单，切换全部看看吧~',
                        isFirstLoading: true,
                        isShowDownLoading: false,
                        requestError: false,
                        isDownLoading: false,
                        pageFull: 0,
                        orderFilter: 1,
                        isFullNodata: false,
                        isReply: false,
                        time: 0,
                        freshNumber: 0,
                        lastTime: '',
                        noDataText: "到底了，在右上角的分类订单找找看~",
                        getMonthsDes: 'leq',                        
                    },
                    waitGoing: {
                        name: '待出行',
                        active: 0,
                        value: 'waitGoing',
                        scrollPosition: 0,
                        nodata: '暂无待出行订单，切换全部看看吧~',
                        isFirstLoading: true,
                        isShowDownLoading: false,
                        requestError: false,
                        isDownLoading: false,
                        pageFull: 0,
                        orderFilter: 3,
                        isFullNodata: false,
                        isReply: false,
                        time: 0,
                        freshNumber: 0,
                        lastTime: '',
                        noDataText: "到底了，在右上角的分类订单找找看~",
                        getMonthsDes: 'leq',                        
                    },
                    waitEvaluate: {
                        name: '待点评',
                        active: 0,
                        value: 'waitEvaluate',
                        scrollPosition: 0,
                        nodata: '暂无待点评订单，切换全部看看吧~',
                        isFirstLoading: true, //第一次加载
                        isShowDownLoading: false, //是否展示下拉加载的图标
                        requestError: false, //请求发生错误
                        isDownLoading: false, //是否正在加载的状态
                        pageFull: 0,
                        orderFilter: 2,
                        isFullNodata: false,
                        isReply: false,
                        time: 0,
                        freshNumber: 0,
                        lastTime: '',
                        noDataText: "到底了，在右上角的分类订单找找看~",
                        getMonthsDes: 'leq',                                           
                    },
                },
                pageSettingMap: {
                    0: { //预订时间排序页面配置
                        Count: 3,
                        Time: 60000,
                        NormalMonths: 3,
                        NormalBeginDate: 0,
                        InForce: true,
                        CancelReasonProjects: [],
                        ready:false
                    },
                    3: { //出行时间排序页面配置
                        Count: 3,
                        Time: 60000,
                        NormalMonths: 12,
                        NormalBeginDate: 0,
                        InForce: false,
                        CancelReasonProjects: [],
                        ready:false
                    }
                },
                pageAllSetting: {
                    NormalMonths: 12,
                    NormalBeginDate: 0,
                    InForce: false,
                    ready: false
                },
                pageWaitingsSetting: {
                    NormalMonths: 12,
                    NormalBeginDate: 0,
                    InForce: false,
                    ready: false
                },
                pageSetting: {
                    NormalMonths: 12,
                    NormalBeginDate: 0,
                    InForce: false,
                    ready: false
                },
                nowActive: 'all', //记录点击更多前的选择
                //所有的数据
                allOrderItems: {
                    all: [],
                    waitApply: [],
                    waitGoing: [],
                    waitEvaluate: []
                },
                scrollHeight: document.documentElement.clientHeight - 50 + '',
                source: null, //存放请求取消的方法
                refs: {}, //所有scroller的
                actposition: '-1',
                indexHome: 'https://wx.17u.cn/home/index.html', //首页地址
                TsDayNow: new Date(new Date().getFullYear() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getDate()).getTime(),
                tclydjxcx:'tclydjxcx',
                isCanalTravel:false,
                isViewBuoy:false,
                isViewWin:false,
                menuValueIndex: {
                    'all': 0,
                    'waitApply': 1,
                    'waitGoing': 3,
                    'waitEvaluate': 2,
                }
            }
        },
        created(){
            // 重定向到新站点 https://wx.17u.cn/ordercenterfrontv2/ordercenter?page=3&tab=0
            const query = this.$route.query;
            const newSite = 'https://wx.17u.cn/ordercenterfrontv2/ordercenter';
            const newUrl = `${newSite}?tab=${this.menuValueIndex[query.orderType || 'all'] || 0}`
            if (query.force != '1'){
                // 非强制进入老订单，重定向到新站点
                AppendTrack(category, action, label, `重定向到新站点：${newUrl}`)
                location.replace(newUrl)
            }
        },
        mounted() {
            const query = this.$route.query;
            if (query.force != '1'){
                return               
            }
            let url = location.href;
            this.nowActive = getStrFromUrl(url, 'orderType');
            this.menu[this.nowActive].active = 1;
            document.title = "我的订单";
            this.refs = {
                all: this.$refs.my_scrollerAll,
                waitApply: this.$refs.my_scrollerApply,
                waitGoing: this.$refs.my_scrollerGoing,
                waitEvaluate: this.$refs.my_scrollerEvaluate,
            }
            let that=this
            if (!this.menu[this.nowActive].isReply) {
                axios.get(api.GetPageSetting, {params: {
                    "miniAppVer": miniAppVer,
                    "cts": new Date().getTime(),
                    "devType": devType,
                    'enterType': enterType
                }}).then(res => {                    
                    if(res.data && res.data.Body) {
                        that.setPageSettingMap(res.data.Body)
                        that.pageAllSetting=that.pageSettingMap[0]  					
                        if (res.data.Body && res.data.Body.ViewInVoice){                            
                            that.menu.all.viewInvoice=res.data.Body.ViewInVoice	
                            that.menu.all.viewInvoiceNum=res.data.Body.ViewInVoice?1:0;
                        } 
                        if (res.data.Body && res.data.Body.InVoiceUrl)   {
                            that.menu.all.invoiceUrl=res.data.Body.InVoiceUrl						
                        }

                        //非all的
                        that.pageWaitingsSetting = Object.assign(that.pageWaitingsSetting, {
                            NormalBeginDate: res.data.Body.NormalBeginDate || 0,
                            NormalMonths: res.data.Body.NormalMonths || 12,
                            ready: true,
                            cancelReasonProjects:res.data.Body.CancelReasonProjects
                        })

                        if(that.pageWaitingsSetting.NormalMonths == 12) {
                            that.pageWaitingsSetting.InForce = false
                        } else {
                            that.pageWaitingsSetting.InForce = true
                        }
                        if(res.data.Body.ExtendData){
                            that.isViewWin=res.data.Body.ExtendData.apptransferwin==="1"
                            that.isViewBuoy=res.data.Body.ExtendData.apptransferwin==="1"
                            if(that.isViewWin){
                                 //debugger
                                 var query=that.$route.query;
                                 if(query&&query.apptransfer==='1'){
                                     setTimeout(()=>{Bus.$emit('showviewapporder')},1000)                                     
                                 }    
                            }
                        }                        
                    }
                    if(that.nowActive == 'all') {
                        that.getFirstData('all')
                        that.pageSetting=that.pageAllSetting
                    }else{
                        that.pageSetting=that.pageWaitingsSetting
                    }
                    
                }).catch(err => {
                    that.pageSetting.ready = true
                    if(that.nowActive == 'all') {
                        that.getFirstData('all')
                    }
                })
            }
            AppendTrack(category, action, label, '^列表曝光^' + this.menu[this.nowActive].name + '^' + openId)                               
        },
        methods: {
            setPageSettingMap(resBody){      
                if (resBody.PageSettingMap){
                    let map = this.pageSettingMap
                    if (resBody.PageSettingMap[0]){
                    this.setPageSettingData(map, resBody,0)                  
                    }
                    if (resBody.PageSettingMap[3]){
                    this.setPageSettingData(map, resBody, 3)         
                    }
                }
            },
            setPageSettingData(map, resBody,i){
                let localPage = map[i]
                let apiPage = resBody.PageSettingMap[i]      
                localPage.Count = apiPage.Count || localPage.Count
                localPage.Time = apiPage.Time || localPage.Time
                localPage.NormalMonths = apiPage.NormalMonths || localPage.NormalMonths
                localPage.NormalBeginDate = apiPage.NormalBeginDate || localPage.NormalBeginDate
                localPage.CancelReasonProjects = resBody.CancelReasonProjects || (localPage.CancelReasonProjects ||[])
                localPage.ready=true

                localPage.InForce = (localPage.NormalMonths != 12)			      			 
            },
            //由于最后才使用四个scroller，导致scrolle未封装成组件，都写到这一个VUE中
            //所以有四个刷新，加载的函数
            refreshAll: function(done) {                
                if (!this.menu.all.isReply && done !== undefined) {
                    this.refresh(done, 'all');
                } else {
                    setTimeout(() => {
                        this.refs.all.finishPullToRefresh()
                    }, 1000);
                }
            },
            infiniteAll: function(done) {
                //不能重复请求
                if (!this.menu.all.isReply && done !== undefined && this.pageSetting.ready) {
                    //如果是第一次请求，不去使用下拉加载来请求第一次
                    if (this.menu.all.isFirstLoading) {
                        // this.getFirstData('all');
                    } else {                        
                        this.infinite(done, 'all')
                    }
                }
            },
            refreshApply: function(done) {
                if (!this.menu.waitApply.isReply && done !== undefined) {
                    this.refresh(done, 'waitApply');
                } else {
                    setTimeout(() => {
                        this.refs.waitApply.finishPullToRefresh()
                    }, 1000);
                }
            },
            infiniteApply: function(done) {               
                if (!this.menu.waitApply.isReply && done !== undefined) {
                    if (this.menu.waitApply.isFirstLoading) {                        
                        this.getFirstData('waitApply');
                    } else {                        
                        this.infinite(done, 'waitApply')
                    }
                }
            },
            refreshGoing: function(done) {
                if (!this.menu.waitGoing.isReply && done !== undefined) {
                    this.refresh(done, 'waitGoing');
                } else {
                    setTimeout(() => {
                        this.refs.waitGoing.finishPullToRefresh()
                    }, 1000);
                }
            },
            infiniteGoing: function(done) {               
                if (!this.menu.waitGoing.isReply && done !== undefined) {
                    if (this.menu.waitGoing.isFirstLoading) {                        
                        this.getFirstData('waitGoing');
                    } else {
                        this.infinite(done, 'waitGoing')
                    }
                }
            },
            refreshEvaluate: function(done) {
                if (!this.menu.waitEvaluate.isReply && done !== undefined) {
                    this.refresh(done, 'waitEvaluate');
                } else {
                    setTimeout(() => {
                        this.refs.waitEvaluate.finishPullToRefresh()
                    }, 1000);
                }
            },
            infiniteEvaluate: function(done) {                
                if (!this.menu.waitEvaluate.isReply && done !== undefined) {
                    if (this.menu.waitEvaluate.isFirstLoading) {
                        this.getFirstData('waitEvaluate');
                    } else {
                        this.infinite(done, 'waitEvaluate')
                    }
                }
            },
            //tab切换
            selectMenuType: function(data) {
                if(data.value=="all"){
                    this.pageSetting=this.pageAllSetting                   
                }else{
                    this.pageSetting=this.pageWaitingsSetting
                }
                let me = this;
                me.actposition= '-1'
                //记住位置
                me.menu[me.nowActive].scrollPosition = this.refs[me.nowActive].getPosition().top;
                setTimeout(() => {
                    me.nowActive = data.value;
                    AppendTrack(category, action, label, '^列表曝光^' + me.menu[this.nowActive].name + '^' +
                        openId + '^')
                    //请求第一次
                    if (me.menu[me.nowActive].isFirstLoading) {
                        me.getFirstData(me.nowActive)
                    }
                    setTimeout(function() {
                        //滚动到原来的位置
                        if (me.allOrderItems[me.nowActive].length > 0) {
                            me.refs[me.nowActive].scrollTo(0, me.menu[me.nowActive].scrollPosition)
                        } else {
                            me.refs[me.nowActive].scrollTo(0, 0)
                        }
                    }, 100)
                }, 0)
            },
            //下拉刷新full接口请求数据
            refresh: function(done, active, isshowToast) {                
                let me = this,
                mynowActive = active;
                me.actposition = '-1';
                me.menu[mynowActive].pageFull = 1;
                me.menu[mynowActive].isReply = true;
                let params = {
                    "miniAppVer": miniAppVer,
                    "cts": new Date().getTime(),
                    "devType": devType,
                    "productId": "0",
                    "pagei": me.menu[mynowActive].pageFull,
                    "count": 10,
                    "orderFilter": me.menu[mynowActive].orderFilter,
                    'enterType': enterType,
                    'ordVer':miniOrderVer,
                }
                if(mynowActive=="all"){
                    params["orderSort"] = me.menu.all.sortType
                }
                
                me.menu[mynowActive].getMonthsDes = 'leq'
                if(me.menu[mynowActive].noThreeMonthOrder){
                    params = Object.assign(params, {
                        "normalMonths": 12,
                        "normalBeginDate": me.pageSetting.NormalBeginDate,
                        "getMonthsDes": 'leq'
                        })
                }else{
                    params = Object.assign(params, {
                        "normalMonths": me.pageSetting.NormalMonths,
                        "normalBeginDate": me.pageSetting.NormalBeginDate,
                        "getMonthsDes": 'leq'
                    })
                }                 
                if(me.isCanalTravel){
                    params["refPlat"]=this.tclydjxcx
                }
                axios.post(api.GetFullOrders, params).then((response) => {                    
                    me.menu[mynowActive].requestError = false;
                    me.menu[mynowActive].lastTime = '';
                    let responseJson = JSON.parse(response.data)
                    me.TsDayNow = responseJson.TsDayNow;
                    let dataTemp = me.detailData(responseJson.Body || [])
                    if (dataTemp && dataTemp.length && dataTemp.length > 0) {
                        me.allOrderItems[mynowActive] = dataTemp.slice(0);
                        me.menu[mynowActive].isFullNodata = false;
                        if (typeof done === 'function') {                            
                            done()
                        } else {
                            me.refs[mynowActive].finishPullToRefresh();
                        }
                    } else {
                        me.menu[mynowActive].isFullNodata = true;
                        me.allOrderItems[mynowActive] = [];
                        if (typeof done === 'function') {
                            done(true)
                        } else {
                            me.refs[mynowActive].finishPullToRefresh(true);
                        }
                    }                    
                    //第一次请求结束
                    if (me.allOrderItems[mynowActive] == 0) {
                        me.menu[mynowActive].isShowDownLoading = false;
                        me.menu[mynowActive].isDownLoading = false;                        
                    } else {
                        me.menu[mynowActive].isShowDownLoading = true;
                    }
                    if (!isshowToast) {
                        me.$toast("更新成功", 'center', 1000)
                    }
                    me.refs[mynowActive].showLoading = false;
                    me.menu[mynowActive].isReply = false;
                    if (me.menu[mynowActive].isFirstLoading) {
                       //第一次加载且有数据
                       me.menu[mynowActive].isFirstLoading = false;
                    }
                }, (reject) => {                    
                    me.menu[mynowActive].isReply = false;
                    // console.log('2' + me.menu[mynowActive].isReply)
                    if (me.menu[mynowActive].isFullNodata) {
                        //如果没有更多数据
                        if (typeof done === 'function') {
                            done(true)
                        } else {
                            me.refs[mynowActive].finishInfinite(true);
                        }
                    } else {
                        if (typeof done === 'function') {
                            done()
                        } else {
                            me.refs[mynowActive].finishInfinite();
                        }
                    }
                    if (me.menu[mynowActive].length == 0) {
                        me.menu[mynowActive].isShowDownLoading = false;
                        me.menu[mynowActive].isDownLoading = false;
                        me.menu[mynowActive].requestError = true;
                    }
                    if (me.menu[mynowActive].isFirstLoading) {
                       //第一次加载且有数据
                       me.menu[mynowActive].isFirstLoading = false;
                    }
                    if (!isshowToast) {
                        me.$toast("更新失败，请重试", 'center', 1000)
                    }
                }).catch(function(error) {
                    // console.log(error);
                    if (me.menu[mynowActive].isFirstLoading) {
                       //第一次加载且有数据
                       me.menu[mynowActive].isFirstLoading = false;
                    }
                })                
                AppendTrack(category, action, label, '^下拉刷新^');
            },
            //上拉加载
            infinite: function(done, mynowActive) {                                
                let me = this;
                //开始展示加载状态
                if (me.allOrderItems[mynowActive].length == 0) {
                    me.menu[mynowActive].isDownLoading = false;
                } else {
                    me.menu[mynowActive].isDownLoading = true;
                }
                me.menu[mynowActive].pageFull += 1;
                me.menu[mynowActive].isReply = true;
                let params = {
                    "miniAppVer": miniAppVer,
                    "cts": new Date().getTime(),
                    "devType": devType,
                    "productId": "0",
                    "pagei": me.menu[mynowActive].pageFull,
                    "count": 10,
                    "orderFilter": me.menu[mynowActive].orderFilter,
                    'enterType': enterType,
                    'ordVer':miniOrderVer,
                }
                if(mynowActive=="all"){
                    params["orderSort"] = me.menu.all.sortType
                }
                if(mynowActive == 'all' && me.pageSetting.InForce) {
                    if(me.menu[mynowActive].noThreeMonthOrder && me.menu.all.getMonthsDes == 'leq'){
                        params = Object.assign(params, {
                            "normalMonths": 12,
                            "normalBeginDate": me.pageSetting.NormalBeginDate,
                            "getMonthsDes": me.menu[mynowActive].getMonthsDes
                         })
                    }else{
                        params = Object.assign(params, {
                            "normalMonths": me.pageSetting.NormalMonths,
                            "normalBeginDate": me.pageSetting.NormalBeginDate,
                            "getMonthsDes": me.menu[mynowActive].getMonthsDes
                        })
                    }                   
                }                
                if(me.isCanalTravel){
                    params["refPlat"]=this.tclydjxcx
                }
                axios.post(api.GetFullOrders, params).then((response) => {
                    // 隐藏网络错误展示
                    me.menu[mynowActive].requestError = false;
                    let dataTemp = me.detailData(JSON.parse(response.data).Body || []);
                    //下拉加载，数组拼接
                    if (dataTemp && dataTemp.length && dataTemp.length > 0) {
                        me.allOrderItems[mynowActive] = me.allOrderItems[mynowActive].concat(dataTemp);
                    } else {
                        if(mynowActive == 'all' && me.menu.all.getMonthsDes == 'leq' && me.pageSetting.InForce) {
                            AppendTrack(category, action, label, `^更多订单曝光^查看${this.pageSetting.NormalMonths}个月前订单^`)
                        }
                    }
                    if (me.menu[mynowActive].isFirstLoading) {
                        //第一次加载且有数据
                        me.menu[mynowActive].isFirstLoading = false;
                    }
                    if (dataTemp && dataTemp.length && dataTemp.length > 0) {
                        //有更多数据
                        me.menu[mynowActive].isFullNodata = false;
                        if (typeof done === 'function') {
                            done()
                        } else {
                            me.refs[mynowActive].finishInfinite();
                        }
                        me.menu[mynowActive].isFullNodata = false;
                    } else {
                        me.menu[mynowActive].isFullNodata = true;
                        if (me.menu[mynowActive].isFullNodata) {
                            //如果两个接口均无更多数据则展示无更多数据
                            if (typeof done === 'function') {
                                done(true)
                            } else {
                                me.refs[mynowActive].finishInfinite(true);
                            }
                        }
                    }
                    if (me.allOrderItems[mynowActive].length == 0) {
                        me.menu[mynowActive].isShowDownLoading = false;
                        me.menu[mynowActive].isDownLoading = false;
                    } else {
                        me.menu[mynowActive].isShowDownLoading = true;
                    }
                    me.menu[mynowActive].isReply = false;
                }, (reject) => {
                    //如果full接口报错，展示无更多数据，不去请求第二个接口
                    if (typeof done === 'function') {
                        done(true)
                    } else {
                        me.refs[mynowActive].finishInfinite(true);
                    }
                    if (me.allOrderItems[mynowActive].length == 0) {
                        me.menu[mynowActive].isShowDownLoading = false;
                        me.menu[mynowActive].isDownLoading = false;
                    }
                    //第一次请求结束
                    if (me.menu[mynowActive].isFirstLoading) {
                        me.menu[mynowActive].isFirstLoading = false;
                    }
                    me.menu[mynowActive].pageFull -= 1;
                    me.menu[mynowActive].isReply = false;
                    // console.log('5' + me.menu[mynowActive].isReply) 
                }).catch(function(error) {
                })
            },
            //第一次请求
            getFirstData(mynowActive) {
                let me = this;
                me.menu[mynowActive].isReply = true;
                me.menu[mynowActive].isDownLoading = true;
                me.menu[mynowActive].pageFull += 1;
                let params = {
                    "miniAppVer": miniAppVer,
                    "cts": new Date().getTime(),
                    "devType": devType,
                    "productId": "0",
                    "pagei": me.menu[mynowActive].pageFull,
                    "count": 10,
                    "orderFilter": me.menu[mynowActive].orderFilter,
                    'enterType': enterType,
                    'ordVer':miniOrderVer,
                }
                if(mynowActive=="all"){
                    params["orderSort"] = me.menu.all.sortType
                }
                if(mynowActive == 'all' && me.pageSetting.InForce) {
                    params = Object.assign(params, {
                        "normalMonths": me.pageSetting.NormalMonths,
                        "normalBeginDate": me.pageSetting.NormalBeginDate,
                        "getMonthsDes": me.menu[mynowActive].getMonthsDes
                    })
                }                      
                if(me.isCanalTravel){
                    params["refPlat"]=this.tclydjxcx
                }         
                axios.post(api.GetFullOrders, params).then((response) => {
                    //网络错误置为false
                    me.menu[mynowActive].requestError = false;
                    me.menu[mynowActive].isReply = false;
                    let responseJson = JSON.parse(response.data)
                    me.TsDayNow = responseJson.TsDayNow;
                    let dataTemp = me.detailData(responseJson.Body || []);
                    //第一次请求直接等于请求的数据
                    me.allOrderItems[mynowActive] = dataTemp.slice(0);                                    
                    if (dataTemp && dataTemp.length >0) {
                    } else {
                        //full接口无数据
                        me.menu[mynowActive].isFullNodata = true;
                    }
                    //full接口第一次请求结束，isFirstLoading置为false，
                    me.menu[mynowActive].isFirstLoading = false;
                    if (me.menu[mynowActive].isFullNodata) {
                        me.refs[mynowActive].finishInfinite(true);
                        AppendTrack(category, action, label, '^无订单^' + me.menu[mynowActive].name + '^' + openId);
                    } else {
                        me.refs[mynowActive].finishInfinite();
                    }
                    if (me.allOrderItems[mynowActive].length == 0) {
                        if(mynowActive == 'all' && me.menu.all.getMonthsDes == 'leq' && me.pageSetting.InForce) {
                            AppendTrack(category, action, label, `^更多订单曝光^查看${this.pageSetting.NormalMonths}个月前订单^`)
                        }
                        me.menu[mynowActive].isShowDownLoading = false;
                        //请求状态完成
                        me.menu[mynowActive].isDownLoading = false;
                    } else {
                        me.menu[mynowActive].isShowDownLoading = true;
                    }                   
                }, (reject) => {
                    //第一次请求发生生错误，不会请求第二个接口
                    if (me.allOrderItems[mynowActive].length == 0) {
                        me.menu[mynowActive].isShowDownLoading = false; //隐藏上拉的转圈
                        me.menu[mynowActive].isDownLoading = false; //结束请求状态
                        me.refs[mynowActive].finishInfinite(true); //scroller上拉不起作用
                        me.menu[mynowActive].requestError = true; //展示网络错误
                    }
                    me.menu[mynowActive].isFirstLoading = false; //第一次请求结束
                    me.menu[mynowActive].pageFull -= 1;
                    me.menu[mynowActive].isReply = false;                   
                }).catch(function(error) {                                    
                })
            },           
            detailData(itemList) {                                
                if (itemList.length == 0) {
                    return itemList
                }
                let list = [];
                //let nowDate = new Date();
                let datesobj={}
                datesobj.today = this.TsDayNow; //new Date(nowDate.getFullYear() + '/' + (nowDate.getMonth() + 1) + '/' + nowDate.getDate()).getTime();
                datesobj.yesterday = datesobj.today - 86400000;
                datesobj.tomorrow = datesobj.today + 86400000;
                let isTravelSort = (this.nowActive==="all" && this.menu.all.sortType==3)
                let typeName = ''
                if (this.nowActive === 'waitGoing'|| isTravelSort) {
                    typeName = '出行日期'                   
                } else {
                    typeName = '预订日期'
                }                
                //列表遍历
                itemList.forEach(item => {                    
                    let detailDate = '';
                    if(isTravelSort){
                            if (item.ExtendData && item.OrderTravelTime) {                            
                                this.appendClassifyDate(list,typeName,item.OrderTravelTime,datesobj,this.menu[this.nowActive])
                                list.push(item);
                            } else {
                                list.push(item);
                                return
                            }
                    }else{
                        if (this.nowActive !== 'waitGoing') {                        
                            if (item.ExtendData && item.ExtendData.BookingDate) {                            
                                this.appendClassifyDate(list,typeName,item.ExtendData.BookingDate,datesobj,this.menu[this.nowActive])                            
                                list.push(item);
                            } else {
                                list.push(item);
                                return
                            }
                        } else {
                            if (item.ExtendData && item.ExtendData.ShowDepartureDate) {                            
                                this.appendClassifyDate(list,typeName,item.ExtendData.ShowDepartureDate,datesobj,this.menu[this.nowActive])
                                list.push(item);
                            } else {
                                list.push(item);
                                return
                            }
                        }
                    }
                })
                return list
            },            
            appendClassifyDate(list,typeName,date,datesobj,pageSetting){                                
                let key=this.getClassifyDate(typeName,date,datesobj)
                if(pageSetting.lastTime!=key){
                    list.push({type: 'date',content:key})
                    pageSetting.lastTime=key
                }
            },
            getClassifyDate(typeName,date,datesobj){                
                let detailDate = date.substr(0, 19).replace(/\-/igm, '/');
                let itemTime = new Date(detailDate).getTime();
                let itemTimeStr = (new Date(detailDate).getMonth() + 1) + '月' + new Date(detailDate).getDate() + '日'
                if (itemTime > datesobj.today && itemTime < datesobj.tomorrow) {
                    return `${typeName + '： ' +itemTimeStr}  今天`
                } 
                if (itemTime > datesobj.yesterday && itemTime < datesobj.today) {
                    return `${typeName + '： ' + itemTimeStr}  昨天`
                } 
                if (itemTime > datesobj.tomorrow && itemTime < datesobj.tomorrow + 86400000){
                    return `${typeName + '： ' + itemTimeStr}  明天`
                }
                return `${typeName + '： ' + itemTimeStr +'  '+ weekday[new Date(detailDate).getDay()]}`
            },
            //删除的回调
            deleteItem(data) {
                let serialNo = data.serialNo,
                    orderId = data.orderId,
                    productId = data.productId,
                    marking = serialNo || orderId;
                let list = Object.assign({}, this.allOrderItems)
                let array = [];
                //查找所有类型的该项目
                for (let i in list) {
                    for (let j in list[i]) {
                        let item = list[i][j];
                        if (productId == item.ProductId && (item.SerialNo === marking || item.OrderId === marking)) {
                            array.push([i, j]);
                        }
                    }
                }
                //删除所有类型中的该项目
                array.forEach((item) => {
                    this.allOrderItems[item[0]].splice([item[1]], 1)
                    let isNowTrueAllData = true;
                    for (let j = 0; j < this.allOrderItems[item[0]].length; j++) {
                        //判断是否删除所有的单子了
                        if (this.allOrderItems[item[0]][j].ProductId) {
                            isNowTrueAllData = false;
                        }
                    }

                    if (this.allOrderItems[item[0]].length == 0) {
                        this.menu[item[0]].isShowDownLoading = false;
                        this.menu[item[0]].isDownLoading = false;
                    }
                    //删除了所有的订单
                    if (isNowTrueAllData) {
                        this.menu[item[0]].isShowDownLoading = false;
                        this.menu[item[0]].isDownLoading = false;
                        this.allOrderItems[item[0]] = [];
                    }
                })

                let elementIndex = 0, isEnd = true, hasLine = false;
                for(let i = 0; i < this.allOrderItems.all.length; i ++) {
                    let element =  this.allOrderItems.all[i]
                    if(element && element.type && element.type == 'cuttingLine') {
                        elementIndex = i
                        hasLine = true
                        break
                    }
                }
                if(hasLine) {
                    for (let i = elementIndex; i < this.allOrderItems.all.length; i++) {
                        let element = this.allOrderItems.all[i]
                        if(element && element.ProductId) {
                            isEnd = false
                            break
                        }
                    }
                }
                if(isEnd && hasLine) {
                    this.allOrderItems.all.splice(elementIndex, 1)
                }
            },
            //订单取消的回调
            cancelItem(data) {
                this.refresh(null, this.nowActive, false);
            },
            ToHereClick(number) {
                let type = 1001
                this.$router.push(`/list/${type}`);
                changeTitle('其他订单')
                Bus.$emit('fromIndexToNow', {
                    type: type,
                    name: '其他'
                })
                if (number == 1) {
                    AppendTrack(category, action, label, '^空态页提示操作^');
                } else {
                    AppendTrack(category, action, label, '^底部提示操作^' + this.menu[this.nowActive].name);
                }
                this.actposition = '-1'
            },
            transformNum(n) {
                let num = parseInt(n)
                let arr = ["零", "一", '二', '三', '四', '五', '六', '七', '八', '九', '十', '十一', '十二']
                return arr[num]
            },
            getGTOrder() {                
                let me = this,
                mynowActive = this.nowActive;
                me.actposition = '-1'; 
                if(me.allOrderItems[mynowActive].length == 0) {
                    me.menu[mynowActive].isFirstLoading = true
                }
                //noThreeMonthOrder参数开始需求是在没有订单时才设置为true,后来需求调整为只有点击按钮后，都设置为true.所以现在改为直接设置为true
                me.menu[mynowActive].noThreeMonthOrder = true
                if(mynowActive == 'all') {
                    AppendTrack(category, action, label, `^更多订单点击^查看${this.pageSetting.NormalMonths}个月前订单^`)
                }
                me.menu[mynowActive].getMonthsDes = 'gt'
                me.menu[mynowActive].isReply = true;
                me.refs[mynowActive].showLoading = true;
                me.menu[mynowActive].isDownLoading = true;
                me.menu[mynowActive].pageFull = 1;
                let params = {
                    "miniAppVer": miniAppVer,
                    "cts": new Date().getTime(),
                    "devType": devType,
                    "productId": "0",
                    "pagei": me.menu[mynowActive].pageFull,
                    "count": 10,
                    "orderFilter": me.menu[mynowActive].orderFilter,
                    'enterType': enterType,
                    "normalMonths": me.pageSetting.NormalMonths,
                    "normalBeginDate": me.pageSetting.NormalBeginDate,
                    "getMonthsDes": me.menu[mynowActive].getMonthsDes,
                    'ordVer':miniOrderVer,
                }
                if(mynowActive=="all"){
                    params["orderSort"] = me.menu.all.sortType
                }                
                if(me.isCanalTravel){
                    params["refPlat"]=this.tclydjxcx
                }
                axios.post(api.GetFullOrders, params).then((response) => {
                    //网络错误置为false
                    me.menu[mynowActive].requestError = false;
                    me.menu[mynowActive].isReply = false;
                    // me.menu[mynowActive].isFirstLoading = false;
                    let responseJson = JSON.parse(response.data)
                    me.TsDayNow = responseJson.TsDayNow;
                    let dataTemp = me.detailData(responseJson.Body || []);
                    if (dataTemp && dataTemp.length && dataTemp.length > 0) {
                        let cuttingLine = {
                            type: 'cuttingLine'
                        }
                        dataTemp.unshift(cuttingLine)
                        me.allOrderItems[mynowActive] = me.allOrderItems[mynowActive].concat(dataTemp);
                    }

                    if (dataTemp && dataTemp.length && dataTemp.length > 0) {
                        //有更多数据
                        me.menu[mynowActive].isFullNodata = false;
                        if (typeof done === 'function') {
                            done()
                        } else {
                            me.refs[mynowActive].finishInfinite();
                        }
                        me.menu[mynowActive].isFullNodata = false;
                    } else {
                        me.menu[mynowActive].isFullNodata = true;
                        if (me.menu[mynowActive].isFullNodata) {
                            if (typeof done === 'function') {
                                done(true)
                            } else {
                                me.refs[mynowActive].finishInfinite(true);
                            }
                        }
                    }
                    if (me.allOrderItems[mynowActive].length == 0) {
                        me.menu[mynowActive].isShowDownLoading = false;
                        //请求状态完成
                        me.menu[mynowActive].isDownLoading = false;
                    } else {
                        me.menu[mynowActive].isShowDownLoading = true;
                    }
                    if (me.menu[mynowActive].isFirstLoading) {
                        me.menu[mynowActive].isFirstLoading = false;
                    }
                }, (reject) => {
                    if (typeof done === 'function') {
                        done(true)
                    } else {
                        me.refs[mynowActive].finishInfinite(true);
                    }
                    if (me.allOrderItems[mynowActive].length == 0) {
                        me.menu[mynowActive].isShowDownLoading = false;
                        me.menu[mynowActive].isDownLoading = false;
                    }
                    if (me.menu[mynowActive].isFirstLoading) {
                        me.menu[mynowActive].isFirstLoading = false;
                    }
                    me.menu[mynowActive].pageFull -= 1;
                    me.menu[mynowActive].isReply = false;
                }).catch(function(error) {
                    if (me.menu[mynowActive].isFirstLoading) {
                        me.menu[mynowActive].isFirstLoading = false;
                    }
                })
            },
            goConsult() {
                location.href = `https://wx.17u.cn/kefu/#/other?plat=wxordercenter`
                AppendTrack(category, action, label, `^订单问题咨询^`)
                this.actposition = '-1'
            },
            closeMore(data) {
               this.actposition = data.actposition
            },
            onsortOrderTime:function(){	                					
                this.menu.all.sortType=0                
                this.pageSetting=this.pageAllSetting=this.pageSettingMap[this.menu.all.sortType]
                this.isInit=false
                this.allOrderItems.all=[]
                this.menu.all.isShowDownLoading=false
                // 大的刷新图片。
                this.menu.all.isFirstLoading=true
                let that=this                
                setTimeout(() => {
                            that.refreshAll(that.refs.all.finishPullToRefresh)
                            //this.openIndicator('正在刷新列表')
                        }, 1000)
            },
            onsortTravelTime:function(){                                						
                this.menu.all.sortType=3               
                this.pageSetting=this.pageAllSetting=this.pageSettingMap[this.menu.all.sortType]
                this.isInit=false                
                this.allOrderItems.all=[]
                this.menu.all.isShowDownLoading=false
                // 大的刷新图片。
                this.menu.all.isFirstLoading=true
                let that=this
                setTimeout(() => {
                            that.refreshAll(that.refs.all.finishPullToRefresh)
                            //this.openIndicator('正在刷新列表')
                        }, 1000)
            }
        },
        beforeMount() {            
            var canal_travel=sessionStorage['wx_home_canal_travel']	
            this.isCanalTravel=	canal_travel=='1'
        },
    }
</script>

<style>
    #app {
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #333;
    }
    .my-item-date {
        background: #c3c8d4;
        border-radius: 0.26rem;
        text-align: left;
        font-size: 0.26rem;
        height: 0.52rem;
        width: fit-content;
        padding: 0 0.35rem;
        margin: 0.4rem 0 0.2rem 0.2rem;
        display: -webkit-box;
        -webkit-box-pack: center;
        -webkit-box-align: center;
        color: #fff;
        font-weight: bold;
    }
    .orderItems {
        font-size: 0.24rem;
    }
    .tips-pic {
        display: block;
        width: 0.26rem;
        height: 0.26rem;
        margin-top: 0.05rem;
        padding: 0.2rem;
    }
    .no-data-show {
        width: 100%;
        height: 100%;
        padding-top: 1.8rem;
        margin: 0 auto;
        font-size: 0.32rem;
        color: #999;
        text-align: center;
    }
    .no-data-show img {
        width: 125px;
    }
    .first-load {
        width: 100%;
        margin: 4rem auto 0;
        text-align: center;
    }
    .first-load img {
        width: 0.6rem;
    }
    .toIndexHome {
        height: 30px;
        line-height: 30px;
        border-radius: 20px;
        width: 100px;
        display: inline-block;
        background: #fff;
        color: #333;
        text-decoration: none;
        display: -webkit-box;
        -webkit-box-pack: center;
        -webkit-box-align: center;
        -webkit-box-orient: vertical;
        text-align: center;
        margin: 20px auto;
    }
    .request-error {
        text-align: center;
        line-height: 0.5rem;
    }
    .to-here-more {
        color: #16ba63;
    }
    .gt-btn {
        background: #fff;
        margin: 0 auto;
        width: 180px;
        height: 30px;
        line-height: 30px;
        display: -webkit-box;
        -webkit-box-align: center;
        -webkit-box-pack: center;
        border-radius: 30px;
        font-size: 14px;
        position: relative;
        color: #333;
        box-shadow: 0 0 0 1px rgba(153,153,153,0.3);
    }
    .gtBtn-box {
        padding: 20px 0 30px;
    }
    .consult-box{
        padding: 20px 0 30px;
    }
    .consult {
        font-size: 12px;
        color: #16b963;
        margin-top: 15px;
        padding-bottom: 50px;
    }
    .consult_null {
        font-size: 12px;
        color: #16b963;
        position: fixed;
        z-index: 10;
        left: 50%;
        bottom: 40px;
        transform: translateX(-50%);
    }
    .load_more_warp {
        display: flex;
        align-items: center;
        justify-content: center;
    }
.cuttingLine {
	width: 100%;
	display: -webkit-box;
	-webkit-box-align: center;
	-webkit-box-pack: center;
    line-height: 0.26rem;
}
.cuttingtext {
    line-height: 0.26rem;
    font-size: 0.26rem;
    color: rgb(170, 170, 170);
    position: relative;
}

.sort_box_postion {
    position: fixed;
    left: 0;
    right: 0;
	top: 50px;
    z-index: 99;
}
</style>


// WEBPACK FOOTER //
// src/page/App.vue